module.exports = __webpack_public_path__ + "static/media/img_system6.2308ee49.png";